import './ShowsLoading.css'
function ShowsLoading() {
    return(
        <>
            <div className='loading'></div>
            <div className='loading'></div>
            <div className='loading'></div>
            <div className='loading'></div>
            <div className='loading'></div>
            <div className='loading'></div>
            <div className='loading'></div>
            <div className='loading'></div>
            <div className='loading'></div>
            <div className='loading'></div>
            <div className='loading'></div>
            <div className='loading'></div>
            <div className='loading'></div>
            <div className='loading'></div>
            <div className='loading'></div>
            <div className='loading'></div>
            <div className='loading'></div>
            <div className='loading'></div>
            <div className='loading'></div>
            <div className='loading'></div>
        </>
     )   
}

export { ShowsLoading }